import { render } from "./task-market.vue?vue&type=template&id=31bdfc8a&scoped=true"
import script from "./task-market.vue?vue&type=script&lang=js"
export * from "./task-market.vue?vue&type=script&lang=js"

import "./task-market.vue?vue&type=style&index=0&id=31bdfc8a&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bdfc8a"]])

export default __exports__